import { GlobalAxios } from "../axios/axios-config";
import { IGetQuickAnswer, INewQuickAnswer } from "../models/quick-answer";

const QUICK_ANSWER_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannelQuickAnswerAdm/";

export const inactiveQuickAnswer = (id: string) => {
  return GlobalAxios.put(QUICK_ANSWER_ROUTE + `${id}/Inactive`, { id });
};

export const createQuickAnswer = (params: INewQuickAnswer) => {
  return GlobalAxios.post(QUICK_ANSWER_ROUTE, params);
};

export const updateQuickAnswer = ({
  id,
  item,
}: {
  id: string;
  item: INewQuickAnswer;
}) => {
  return GlobalAxios.put(QUICK_ANSWER_ROUTE + id, item);
};

export const getQuickAnswer = (id: string) => {
  return GlobalAxios.get<IGetQuickAnswer>(QUICK_ANSWER_ROUTE + id);
};
